import $ from 'jquery';
import CustomEvent from 'custom-event';

const namespace = 'giftwrap';

export default class GiftWrap {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          toggle: '.js-giftwrap-toggle',
          remove: '#remove-gift-wrap',
        },
        data: {
          config: '[data-giftwrap-config]',
        },
      },
      options,
    );

    this.$el = $(el);
    this.el = this.$el.get(0);
    this.configJson = $(this.options.data.config).html();
    this.isUpdating = false;

    if (!this.configJson) {
      return;
    }

    this.config = JSON.parse(this.configJson);

    this.bind();
    this.check();
  }

  bind() {
    this.$el.on(
      `change.${namespace}`,
      this.options.selectors.toggle,
      this.handleCheck.bind(this),
    );

    this.bindRemove();
  }

  check() {
    if (this.isUpdating) return null;

    const {cartSize, wrapCount, attribute} = this.config;
    const size = parseInt(cartSize, 10);
    const count = parseInt(wrapCount, 10);

    if (size === 1 && count >= 1) {
      return this.remove().then(this.reload.bind(this));
    }

    if (count > 0 && !attribute) {
      return this.add().then(this.reload.bind(this));
    }

    if (attribute && count === 0) {
      return this.remove().then(this.reload.bind(this));
    }

    return null;
  }

  reload() {
    if (!this.isUpdating) {
      window.location.reload();
    }
  }

  /**
   * @param {Event} event
   */
  handleCheck(event) {
    if (this.isUpdating) return;

    const {currentTarget} = event;
    const state = $(currentTarget).is(':checked');
    const action = state ? this.add.bind(this) : this.remove.bind(this);

    action()
      .then(this.reload.bind(this))
      .catch(window.console.log);
  }

  /**
   * @returns {Promise}
   */
  add() {
    if (this.isUpdating) return Promise.reject(new Error('Update in progress'));
    
    this.isUpdating = true;
    console.log('add GiftWrap');
    const addedEvent = new CustomEvent('giftWrapAdded', {
      bubbles: true,
    });

    this.el.dispatchEvent(addedEvent);

    return this.update(1, 'yes');
  }

  /**
   * @returns {Promise}
   */
  remove() {
    if (this.isUpdating) return Promise.reject(new Error('Update in progress'));

    this.isUpdating = true;
    console.log('remove GiftWrap');
    const removedEvent = new CustomEvent('giftWrapRemoved', {
      bubbles: true,
    });

    this.el.dispatchEvent(removedEvent);

    return this.update(0, '');
  }

  /**
   * @param {Number} qty
   * @param {String} state
   */
  update(qty, state) {
    return $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: {[this.config.id]: qty},
        attributes: {'gift-wrapping': state},
      },
      dataType: 'json',
    }).then((response) => {
      this.isUpdating = false;
      return response;
    }).catch((error) => {
      this.isUpdating = false;
      throw error;
    });
  }

  bindRemove() {
    $(this.options.selectors.remove).on('click', (event) => {
      if (this.isUpdating) return;
      
      console.log('remove GiftWrap');
      event.preventDefault();
      $(this.options.selectors.toggle).prop('checked', false);
      this.remove()
        .then(this.reload.bind(this))
        .catch(window.console.log);
    });
  }
}
